import { useListing } from 'framework-listing-lib/internal/providers/ListingProvider';
export default function useSkipCrm() {
  "use memo";

  const {
    skipCrm
  } = useListing();
  return Boolean(skipCrm);
}